import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';
import Card from '../../Card';
import { StyledIcon } from '../../RoundIcon/styles';
import { StyledTag } from '../../Tag/styles';

export const StyledCards = styled.div`
  display: grid;
  grid-row-gap: ${themeGet('scale.scaleBase')};
  grid-template-columns: 100%;

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    padding: 0 2rem;
    grid-column-gap: ${themeGet('scale.scaleUp05')};
    grid-row-gap: ${themeGet('scale.scaleUp07')};
  }
`;

export const StyledCard = styled(Card)`
  display: grid;
  grid-template-columns: 100%;
  grid-column-gap: ${themeGet('scale.scaleBase')};
  grid-template-areas: 'media' 'content';
  align-items: start;
  position: relative;

  ${StyledTag} {
    position: absolute;
    top: ${themeGet('scale.scaleDown03')};
    right: ${themeGet('scale.scaleDown03')};
  }

  ${StyledIcon} {
    grid-area: icon;
  }

  > h3 {
    grid-area: title;
    margin: 0;
    padding-top: ${themeGet('scale.scaleDown03')};
    font-size: ${themeGet('scale.scaleUp02')};
    color: ${themeGet('color.colorGrayBlue70')};
  }

  > div {
    grid-area: content;
  }

  p {
    margin-top: ${themeGet('scale.scaleDown03')};
    margin-bottom: ${themeGet('scale.scaleBase')};
  }

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    grid-template-columns: 1fr 3fr;
    grid-template-areas: 'media content';

    ${StyledTag} {
      top: ${themeGet('scale.scaleBase')};
      right: ${themeGet('scale.scaleBase')};
    }

    p {
      margin-bottom: ${themeGet('scale.scaleUp03')};
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    p {
      margin-top: ${themeGet('scale.scaleBase')};
      margin-bottom: ${themeGet('scale.scaleUp07')};
    }
  }
`;

export const StyledGraphic = styled.figure`
  position: relative;
  display: none;

  img {
    object-fit: contain !important;
    object-position: left bottom !important;
  }

  .gatsby-image-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;

    > div {
      display: none;
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    display: block;
  }
`;

export const StyledMedia = styled.figure`
  grid-area: media;
  margin-bottom: ${themeGet('scale.scaleUp03')};
  overflow: hidden;
  box-shadow: ${(props) =>
    props.mediaType === 'CodeExample'
      ? '0 0 1px 0 #a8b9d5, 0 7px 11px -4px rgba(0, 23, 62, 0.2)'
      : null};

  @media (max-width: ${themeGet('breakpoint.breakpointMobile')}) {
    .gatsby-image-wrapper {
      max-height: 270px;
      img {
        object-fit: contain !important;
      }
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    margin-bottom: 0;
  }
`;
